<div class="table-container">
  <p-table [value]="payments" dataKey="_id" [scrollable]="true" scrollHeight="480px" styleClass="p-datatable-sm amortization-table">
    <ng-template pTemplate="header">
      <tr><th>Clave</th><th>Pagó</th><th>Registrado</th><th class="text-right">Monto</th><th class="text-right">Aplicado</th><th class="text-right">Disponible</th><th>Letras</th><th>Registró</th><th>Estado</th><th></th></tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [class.is-cancelled]="row.status === 'CANCELLED'">
        <td>
          <button type="button" class="pd-link" (click)="openPayment.emit(row._id)">{{ row.trackingKey }}</button>
          <p-tag *ngIf="hasTwins(row)" value="posible duplicado" icon="pi pi-clone" severity="warning" styleClass="pv-twin" pTooltip="Tiene un gemelo (mismo cliente, monto y fecha o clave): evidencia, no veredicto. Abre el cajón para verlo." tooltipPosition="top"></p-tag>
        </td>
        <td>{{ row.paidOn | date:'dd/MM/yyyy':'UTC' }}</td>
        <td>{{ row.registeredOn | date:'dd/MM/yyyy' }} <span *ngIf="row.registrationLagDays > 0" class="enf-chip" tabindex="0" [attr.aria-label]="'Registrado ' + row.registrationLagDays + (row.registrationLagDays === 1 ? ' día' : ' días') + ' después de que pagó'">+{{ row.registrationLagDays }} d</span></td>
        <td class="text-right">{{ row.amount | currency }}</td>
        <td class="text-right">{{ row.applied | currency }}</td>
        <td class="text-right font-bold">{{ row.pendingToApply | currency }}</td>
        <td>{{ letters(row) }}</td>
        <td>{{ row.registeredBy || '—' }}</td>
        <td><p-tag [value]="statusLabel(row.status)" [severity]="statusSeverity(row.status)"></p-tag></td>
        <td class="text-right">
          <ng-container *appIfHasPermission="['applications','create']">
            <button *ngIf="row.pendingToApply > 0 && row.status !== 'CANCELLED'" pButton type="button" label="Aplicar" icon="pi pi-check" class="p-button-sm p-button-text p-button-success" (click)="apply.emit(row)"></button>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage"><tr><td colspan="10" class="text-center text-color-secondary p-3">Este arrendamiento no tiene pagos.</td></tr></ng-template>
  </p-table>
</div>
